import axios from "axios";
import {BASE_URL} from "../../constants/API";

export async function getFaqHeader() {
    return await axios.get(BASE_URL + '/faq-headers?populate=image');
}

export async function getFaqQuestions() {
    return await axios.get(BASE_URL + '/faq-questions');
}